var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import SlideView from '@/components/SlideView.vue';
import ExamineTabs from './ExamineTabs.vue';
import MyExamine from '@/wkcrmViews/oa/taskExamine/examine/index.vue';
import CrmExamine from '@/wkcrmViews/oa/taskExamine/crm/index.vue';
import { Component, Vue } from 'vue-property-decorator';
var Examine = /** @class */ (function (_super) {
    __extends(Examine, _super);
    function Examine() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.active = 'my';
        return _this;
    }
    Object.defineProperty(Examine.prototype, "examineView", {
        get: function () {
            var active = this.active;
            if (['my', 'wait'].includes(active)) {
                return 'MyExamine';
            }
            else {
                return 'CrmExamine';
            }
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 动画结束页面展示
     */
    Examine.prototype.viewAfterEnter = function () {
    };
    Examine = __decorate([
        Component({
            components: {
                SlideView: SlideView,
                ExamineTabs: ExamineTabs,
                MyExamine: MyExamine,
                CrmExamine: CrmExamine
            },
        })
    ], Examine);
    return Examine;
}(Vue));
export default Examine;
